import {
  getScanGroup,
  getScanPhotoScanVideoId,
  type ScanRootOptimized,
} from '@kaiizen/kai-scan-template-system';

/** Counts clip stills on one group's rollup for the open walkthrough video. */
export const countScanVideoClipStills = (
  scanRoot: ScanRootOptimized | undefined,
  groupId: string | undefined,
  scanVideoId: string | undefined,
): number => {
  if (!scanRoot || !groupId || !scanVideoId) return 0;
  const group = getScanGroup(scanRoot, groupId);
  return (group.optimized.allPhotos ?? []).filter(
    photo => getScanPhotoScanVideoId(photo) === scanVideoId && photo.videoFrameTimeSeconds != null,
  ).length;
};

export const formatClipStillsCaption = (count: number): string => `${count} still${count === 1 ? '' : 's'} pulled from this clip`;
